const mode = 'PROD';

export const API_BASE_URL =
    mode === 'DEV'
        ? 'http://localhost/alefolia/src/php'
        : 'https://admin.alefolia.com/backend/php';
